import { IconComponent } from '../icons/types';

type IconMapping = Record<string, IconComponent>;
type ModuleMapping = Record<string, IconMapping>;

// Auto-import every component in the ../icons directory:
const icons: IconMapping = {};
const req: ModuleMapping = import.meta.glob('../icons/*.[tj]sx', {
  eager: true,
});

Object.keys(req).forEach((key) => {
  const componentName = key.replace(/^.+\/([^/]+)\.[tj]sx$/, '$1');
  const obj = req[key];
  if (obj.default) {
    icons[componentName] = obj.default;
  } else {
    Object.entries(obj).forEach(([k, value]) => {
      icons[k] = value;
    });
  }
});

const iconNames = Object.keys(icons).sort();

// Display grid of all icons:
const AllIcons = () => {
  return (
    <div
      className="p-5"
      style={{
        overflowY: 'auto',
        height: '100vh',
      }}
    >
      <h1>All Icons</h1>
      <div className="d-flex flex-wrap justify-content-between mt-3">
        {iconNames.map((iconName) => {
          const Icon = icons[iconName];
          return (
            <div
              className="d-flex mb-3"
              style={{ width: '33%', minWidth: '240px' }}
              key={iconName}
            >
              <div className="pr-3 font-large" style={{ width: '200px' }}>
                {iconName}
              </div>
              <div>
                {Icon ? <Icon width={20} height={20} /> : '(import failed)'}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AllIcons;
